import { render, staticRenderFns } from "./EditableItemSimple.vue?vue&type=template&id=27bd759c&scoped=true&"
import script from "./EditableItemSimple.vue?vue&type=script&lang=js&"
export * from "./EditableItemSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bd759c",
  null
  
)

export default component.exports